import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { ListPageTemplate } from '../../components/Templates';
import { useTradingAccounts } from '../../components/Accounts';
import { useAppContext } from '../../contexts/Storage';

const TradingAccountsPage: React.FC = () => {
  const { selectedRecord } = useAppContext();
  const navigate = useNavigate();

  const {
    listItems,
    isLoading,
    hasRequiredParams,
  } = useTradingAccounts();

  // Show message if no record is selected
  if (!selectedRecord) {
    return (
      <div className="h-shink-from-navbar h-fill-from-navbar px-2 bg-bg_grey_light text-dark">
        <div className="max-w-7xl mx-auto">
          <div className="p-6 bg-light rounded-lg flex flex-col items-center justify-center min-h-[200px]">
            <p className="text-grey_dark mb-4">Please select a record to view trading accounts.</p>
            <Link
              to="/records"
              className="text-primary hover:text-primary_dark underline"
            >
              Go to Records
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ListPageTemplate
      title="Trading Accounts"
      description="Manage trading account folders"
      items={listItems}
      loading={isLoading && hasRequiredParams}
      onItemClick={(item) => navigate(`/records/accounts/trading-accounts/${item.id}`)}
      emptyMessage="No trading accounts found."
    />
  );
};

export default TradingAccountsPage;
